import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./navbar.css";
import CompanyLogo from "../../Assets/Images/company_logo.png";
import CartIcon from "../../Assets/Icons/CartIcon";
import UserIcon from "../../Assets/Icons/UserIcon";
import HamburgerIcon from "../../Assets/Icons/HamburgerIcon";
import { useLogin } from "../../APIContext/LoginContext";
import { useNewUser } from "../../APIContext/NewUserContext";
import { Menubar } from "primereact/menubar";
import { Sidebar } from "primereact/sidebar";
import { useNavigate } from "react-router-dom";
import NotificationBell from "../Notification/NotificationBell";
import { useLocation } from "react-router-dom";
import { useSummerCamp } from "../../APIContext/summerCampContext";

const NavbarCustom = () => {
  const navigate = useNavigate();
  const { user, setUser } = useLogin();
  const { fetchCartCount, cartRe, loading } = useNewUser();
  const { getOfferingCart, summerCampList } = useSummerCamp();
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const location = useLocation();
  const external_link = "https://fixmyjumpshot.shootinschool.com/";

  
console.log("Navbar render");
  console.log("User value:", user);
 


  useEffect(() => {
    // if (!user || user.role !== "PARENT") return;
     
    const fetchOfferings = async () => {
      try {
        await Promise.all([getOfferingCart(), fetchCartCount()]);
      } catch (error) {
        console.error("Error while fetching data", error);
      }
    };

    fetchOfferings();
  }, [user]);


  if (!user || user.role !== "PARENT") {
      localStorage.removeItem("user");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
    }


    
  // Menu items when NOT logged in
  const menuItemsGuestDesktop = [
    {
      label: "Home",
      template: () => (
        <Link to="/" onClick={() => setSidebarVisible(false)}>
          Home
        </Link>
      ),
    },
    // { label: "Your Packages", template: () => <Link to="/your-packages" onClick={() => setSidebarVisible(false)}>Your Packages</Link> },
    {
      label: "About",
      items: [
        {
          label: "About Us",
          template: () => (
            <Link to="/about/" onClick={() => setSidebarVisible(false)}>
              About Us
            </Link>
          ),
        },
        {
          label: "Success Stories",
          template: () => (
            <Link
              to="/shootin-school-success-stories/"
              onClick={() => setSidebarVisible(false)}
            >
              Success Stories
            </Link>
          ),
        },
        {
          label: "Sponsors",
          template: () => (
            <Link to="/sponsors/" onClick={() => setSidebarVisible(false)}>
              Sponsors
            </Link>
          ),
        },
      ],
    },
    {
      label: "Services",
      items: [
        {
          label: "Instruction",
          template: () => (
            <Link to="/instruction/" onClick={() => setSidebarVisible(false)}>
              Instruction
            </Link>
          ),
        },
        {
          label: "Summer Camp",
          template: () => (
            <Link
              to="/basketball-summer-camps"
              onClick={() => setSidebarVisible(false)}
            >
              Summer Camp
            </Link>
          ),
        },
        {
          label: "Team Workouts",
          template: () => (
            <Link to="/team-workout" onClick={() => setSidebarVisible(false)}>
              Team Workouts
            </Link>
          ),
        },
        {
          label: "Clinics",
          template: () => (
            <Link to="/clinics/" onClick={() => setSidebarVisible(false)}>
              Clinics
            </Link>
          ),
        },
        {
          label: "Programs",
          template: () => (
            <Link to="/programs/" onClick={() => setSidebarVisible(false)}>
              Programs
            </Link>
          ),
        },
        {
          label: "Birthday Parties",
          template: () => (
            <Link
              to="/birthday-parties-registration-form/"
              onClick={() => setSidebarVisible(false)}
            >
              Birthday Parties
            </Link>
          ),
        },
      ],
    },
    // { label: "Weekly Schedule", template: () => <Link to="/weekly-schedule" onClick={() => setSidebarVisible(false)}>Weekly Schedule</Link> },
    {
      label: "Online Shooting Course",
      command: () => {
        window.open(external_link, "_blank");
      },
    },
    {
      label: "Contact",
      template: () => (
        <Link to="/contact/" onClick={() => setSidebarVisible(false)}>
          Contact
        </Link>
      ),
    },
    {
      label: "How to Schedule",
      template: () => (
        <Link to="/how-to-schedule/" onClick={() => setSidebarVisible(false)}>
          How to Schedule
        </Link>
      ),
    },
  ];

  // Menu items when NOT logged in
  const menuItemsGuestMobile = [
    {
      label: "Home",
      template: () => (
        <Link to="/" onClick={() => setSidebarVisible(false)}>
          Home
        </Link>
      ),
    },
    // { label: "Your Packages", template: () => <Link to="/your-packages" onClick={() => setSidebarVisible(false)}>Your Packages</Link> },
    {
      label: "About",
      items: [
        {
          label: "About Us",
          template: () => (
            <Link to="/about/" onClick={() => setSidebarVisible(false)}>
              About Us
            </Link>
          ),
        },
        {
          label: "Success Stories",
          template: () => (
            <Link
              to="/shootin-school-success-stories/"
              onClick={() => setSidebarVisible(false)}
            >
              Success Stories
            </Link>
          ),
        },
        {
          label: "Sponsors",
          template: () => (
            <Link to="/sponsors/" onClick={() => setSidebarVisible(false)}>
              Sponsors
            </Link>
          ),
        },
      ],
    },
    {
      label: "Services",
      items: [
        {
          label: "Instruction",
          template: () => (
            <Link to="/instruction/" onClick={() => setSidebarVisible(false)}>
              Instruction
            </Link>
          ),
        },
        {
          label: "Summer Camp",
          template: () => (
            <Link
              to="/basketball-summer-camps"
              onClick={() => setSidebarVisible(false)}
            >
              Summer Camp
            </Link>
          ),
        },
        {
          label: "Team Workouts",
          template: () => (
            <Link to="/team-workout" onClick={() => setSidebarVisible(false)}>
              Team Workouts
            </Link>
          ),
        },
        {
          label: "Clinics",
          template: () => (
            <Link to="/clinics/" onClick={() => setSidebarVisible(false)}>
              Clinics
            </Link>
          ),
        },
        {
          label: "Programs",
          template: () => (
            <Link to="/programs/" onClick={() => setSidebarVisible(false)}>
              Programs
            </Link>
          ),
        },
        {
          label: "Birthday Parties",
          template: () => (
            <Link
              to="/birthday-parties-registration-form/"
              onClick={() => setSidebarVisible(false)}
            >
              Birthday Parties
            </Link>
          ),
        },
      ],
    },
    // { label: "Weekly Schedule", template: () => <Link to="/weekly-schedule" onClick={() => setSidebarVisible(false)}>Weekly Schedule</Link> },
    {
      label: "Online Shooting Course",
      command: () => {
        window.open(external_link, "_blank");
      },
    },
    {
      label: "Contact",
      template: () => (
        <Link to="/contact/" onClick={() => setSidebarVisible(false)}>
          Contact
        </Link>
      ),
    },
    {
      label: "How to Schedule",
      template: () => (
        <Link to="/how-to-schedule/" onClick={() => setSidebarVisible(false)}>
          How to Schedule
        </Link>
      ),
    },
    {
      label: "Log Out",
      // Use a functional template for the Logout button
      template: () => (
        <button
          onClick={() => navigate("/login")}
          className="p-link"
          style={{ color: "#F68E1B", fontWeight: "bold" }}
        >
          Sign Up / Login
        </button>
      ),
    },
  ];

  // Menu items when logged in
  const menuItemsUserDesktop = [
    {
      label: "Home",
      template: () => (
        <Link to="/" onClick={() => setSidebarVisible(false)}>
          Home
        </Link>
      ),
    },
    {
      label: "Your Packages",
      template: () => (
        <Link to="/your-packages" onClick={() => setSidebarVisible(false)}>
          Your Packages
        </Link>
      ),
    },
    {
      label: "About",
      items: [
        {
          label: "About Us",
          template: () => (
            <Link to="/about/" onClick={() => setSidebarVisible(false)}>
              About Us
            </Link>
          ),
        },
        {
          label: "Success Stories",
          template: () => (
            <Link
              to="/shootin-school-success-stories/"
              onClick={() => setSidebarVisible(false)}
            >
              Success Stories
            </Link>
          ),
        },
        {
          label: "Sponsors",
          template: () => (
            <Link to="/sponsors/" onClick={() => setSidebarVisible(false)}>
              Sponsors
            </Link>
          ),
        },
      ],
    },
    {
      label: "Services",
      items: [
        {
          label: "Instruction",
          template: () => (
            <Link to="/instruction/" onClick={() => setSidebarVisible(false)}>
              Instruction
            </Link>
          ),
        },
        {
          label: "Summer Camp",
          template: () => (
            <Link
              to="/basketball-summer-camps"
              onClick={() => setSidebarVisible(false)}
            >
              Summer Camp
            </Link>
          ),
        },
        {
          label: "Team Workouts",
          template: () => (
            <Link to="/team-workout" onClick={() => setSidebarVisible(false)}>
              Team Workouts
            </Link>
          ),
        },
        {
          label: "Clinics",
          template: () => (
            <Link to="/clinics/" onClick={() => setSidebarVisible(false)}>
              Clinics
            </Link>
          ),
        },
        {
          label: "Programs",
          template: () => (
            <Link to="/programs/" onClick={() => setSidebarVisible(false)}>
              Programs
            </Link>
          ),
        },
        {
          label: "Birthday Parties",
          template: () => (
            <Link
              to="/birthday-parties-registration-form/"
              onClick={() => setSidebarVisible(false)}
            >
              Birthday Parties
            </Link>
          ),
        },
      ],
    },
    // { label: "Weekly Schedule", template: () => <Link to="/weekly-schedule" onClick={() => setSidebarVisible(false)}>Weekly Schedule</Link> },
    {
      label: "Online Shooting Course",
      command: () => {
        window.open(external_link, "_blank");
      },
    },
    {
      label: "Contact",
      template: () => (
        <Link to="/contact/" onClick={() => setSidebarVisible(false)}>
          Contact
        </Link>
      ),
    },
    {
      label: "How to Schedule",
      template: () => (
        <Link to="/how-to-schedule/" onClick={() => setSidebarVisible(false)}>
          How to Schedule
        </Link>
      ),
    },
  ];

  // Menu items when logged in
  const menuItemsUserMobile = [
    {
      label: "Home",
      template: () => (
        <Link to="/" onClick={() => setSidebarVisible(false)}>
          Home
        </Link>
      ),
    },
    {
      label: "Your Packages",
      template: () => (
        <Link to="/your-packages" onClick={() => setSidebarVisible(false)}>
          Your Packages
        </Link>
      ),
    },
    {
      label: "About",
      items: [
        {
          label: "About Us",
          template: () => (
            <Link to="/about/" onClick={() => setSidebarVisible(false)}>
              About Us
            </Link>
          ),
        },
        {
          label: "Success Stories",
          template: () => (
            <Link
              to="/shootin-school-success-stories/"
              onClick={() => setSidebarVisible(false)}
            >
              Success Stories
            </Link>
          ),
        },
        {
          label: "Sponsors",
          template: () => (
            <Link to="/sponsors/" onClick={() => setSidebarVisible(false)}>
              Sponsors
            </Link>
          ),
        },
      ],
    },
    {
      label: "Services",
      items: [
        {
          label: "Instruction",
          template: () => (
            <Link to="/instruction/" onClick={() => setSidebarVisible(false)}>
              Instruction
            </Link>
          ),
        },
        {
          label: "Summer Camp",
          template: () => (
            <Link
              to="/basketball-summer-camps"
              onClick={() => setSidebarVisible(false)}
            >
              Summer Camp
            </Link>
          ),
        },
        {
          label: "Team Workouts",
          template: () => (
            <Link to="/team-workout" onClick={() => setSidebarVisible(false)}>
              Team Workouts
            </Link>
          ),
        },
        {
          label: "Clinics",
          template: () => (
            <Link to="/clinics/" onClick={() => setSidebarVisible(false)}>
              Clinics
            </Link>
          ),
        },
        {
          label: "Programs",
          template: () => (
            <Link to="/programs/" onClick={() => setSidebarVisible(false)}>
              Programs
            </Link>
          ),
        },
        {
          label: "Birthday Parties",
          template: () => (
            <Link
              to="/birthday-parties-registration-form/"
              onClick={() => setSidebarVisible(false)}
            >
              Birthday Parties
            </Link>
          ),
        },
      ],
    },
    // { label: "Weekly Schedule", template: () => <Link to="/weekly-schedule" onClick={() => setSidebarVisible(false)}>Weekly Schedule</Link> },
    {
      label: "Online Shooting Course",
      command: () => {
        window.open(external_link, "_blank");
      },
    },
    {
      label: "Contact",
      template: () => (
        <Link to="/contact/" onClick={() => setSidebarVisible(false)}>
          Contact
        </Link>
      ),
    },
    {
      label: "How to Schedule",
      template: () => (
        <Link to="/how-to-schedule/" onClick={() => setSidebarVisible(false)}>
          How to Schedule
        </Link>
      ),
    },
    {
      label: "My Profile",
      items: [
        {
          label: "Profile Details",
          template: () => (
            <Link to="/profile" onClick={() => setSidebarVisible(false)}>
              Profile Details
            </Link>
          ),
        },
        {
          label: "My Players",
          template: () => (
            <Link
              to="/profile/players"
              onClick={() => setSidebarVisible(false)}
            >
              My Players
            </Link>
          ),
        },
        {
          label: "Payments & Billings",
          template: () => (
            <Link
              to="/profile/billing"
              onClick={() => setSidebarVisible(false)}
            >
              Payments & Billings
            </Link>
          ),
        },

        {
          label: "Payment Methods",
          template: () => (
            <Link
              to="/profile/payment-methods"
              onClick={() => setSidebarVisible(false)}
            >
              Payment Methods
            </Link>
          ),
        },
          {
          label: "My Summer Camp",
          template: () => (
            <Link
              to="/profile/my-summer-camp"
              onClick={() => setSidebarVisible(false)}
            >
             My Summer Camp
            </Link>
          ),
        },

        {
          label: "My Packages",
          template: () => (
            <Link
              to="/profile/packages"
              onClick={() => setSidebarVisible(false)}
            >
              My Packages
            </Link>
          ),
        },
        {
          label: "My Sessions",
          template: () => (
            <Link
              to="/profile/my-sessions"
              onClick={() => setSidebarVisible(false)}
            >
              My Sessions
            </Link>
          ),
        },
        {
          label: "Notifications",
          template: () => (
            <Link
              to="/profile/notifications"
              onClick={() => setSidebarVisible(false)}
            >
              Notifications
            </Link>
          ),
        },
        {
          label: "Change Password",
          template: () => (
            <Link
              to="/profile/password"
              onClick={() => setSidebarVisible(false)}
            >
              Change Password
            </Link>
          ),
        },
      ],
    },
    {
      label: "Log Out",
      // Use a functional template for the Logout button
      template: () => (
        <button
          onClick={() => {
            localStorage.clear();
            setUser(null);
            navigate("/login");
          }}
          className="p-link"
          style={{ color: "#F68E1B", fontWeight: "bold" }}
        >
          Log Out
        </button>
      ),
    },
  ];

  // Logo
  const start = (
    <Link to="/" onClick={() => setSidebarVisible(false)}>
      <img src={CompanyLogo} alt="Logo" className="navbar-logo" />
    </Link>
  );

  // Right side (login button or icons + hamburger)
  const mobileEnd =
    !user || (user && user.role !== "PARENT") ? (
      <div className="navbar-icons">
        <Link
          to="/cart"
          className="nav-icon cart-icon-a"
          onClick={() => setSidebarVisible(false)}
        >
          <CartIcon
            className="nav-icon"
            count={cartRe + summerCampList?.length || 0}
          />
        </Link>
        <button
          className="nav-icon hamburger-icon"
          onClick={() => setSidebarVisible(true)}
        >
          <HamburgerIcon />
        </button>
      </div>
    ) : (
      <div className="navbar-icons">
        <NotificationBell />
        <Link
          to="/cart"
          className="nav-icon cart-icon-a"
          onClick={() => setSidebarVisible(false)}
        >
          <CartIcon
            className="nav-icon"
            count={cartRe + summerCampList?.length || 0}
          />
        </Link>
        <button
          className="nav-icon hamburger-icon"
          onClick={() => setSidebarVisible(true)}
        >
          <HamburgerIcon />
        </button>
      </div>
    );

  // Right side (login button or icons + hamburger)
  const deskEnd =
    !user || (user && user.role !== "PARENT") ? (
      <div className="navbar-icons">
        <Link
          to="/cart"
          className="nav-icon cart-icon-a"
          onClick={() => setSidebarVisible(false)}
        >
          <CartIcon
            className="nav-icon"
            count={cartRe + summerCampList?.length || 0}
          />
        </Link>
        <Link
          to="/login"
          className="register-login-btn"
          onClick={() => setSidebarVisible(false)}
        >
          Sign Up / Login
        </Link>
      </div>
    ) : (
      <div className="navbar-icons">
        <NotificationBell />
        <Link
          to="/cart"
          className="nav-icon cart-icon-a"
          onClick={() => setSidebarVisible(false)}
        >
          <CartIcon
            className="nav-icon"
            count={cartRe + summerCampList?.length || 0}
          />
        </Link>
        <Link
          to="/profile"
          className="nav-icon"
          onClick={() => setSidebarVisible(false)}
        >
          <UserIcon className="nav-icon" />
        </Link>
      </div>
    );

  return (
    <nav className="section-full-w-row navbar-container">
      <div className="section-boxed-w-row">
        {/* Desktop Navbar */}
        <div className="desktop-navbar">
          <Menubar
            model={
              user && user.role === "PARENT"
                ? menuItemsUserDesktop
                : menuItemsGuestDesktop
            }
            start={start}
            end={deskEnd}
            className={
              user && user.role === "PARENT"
                ? "login-menubar"
                : "not-login-menubar"
            }
          />
        </div>

        <div className="mobile-header-bar">
          {start}
          {mobileEnd}
        </div>

        <Sidebar
          visible={sidebarVisible}
          position="right"
          onHide={() => setSidebarVisible(false)}
          className="mobile-sidebar"
        >
          <div className="mobile-sidebar-header">
            {start}
            <button
              className="close-btn"
              onClick={() => setSidebarVisible(false)}
            >
              ✕
            </button>
          </div>

          <Menubar
            model={
              user && user.role === "PARENT"
                ? menuItemsUserMobile
                : menuItemsGuestMobile
            }
            className={
              user && user.role === "PARENT"
                ? "login-menubar"
                : "not-login-menubar"
            }
          />
        </Sidebar>
      </div>
    </nav>
  );
};

export default NavbarCustom;
